<template>
  <div>
    <b-modal
      :id="`modal-permissions-${id}`"
      :title="`${this.$t('menu.settings.users.titlePermissions', {
        userName: `${user.name}`,
      })}`"
      size="xl"
      style="min-height: 1000px;"
    >
      <b-tabs content-class="mt-3">
        <b-tab
          active
          :title="`${this.$t('menu.settings.users.titleBranches')}`"
        >
          <branch-permissions :user="user" />
        </b-tab>
        <b-tab :title="`${this.$t('menu.settings.users.titleIh2')}`">
          <IH-permissions :user="user" />
        </b-tab>
        <b-tab :title="`${this.$t('menu.settings.users.titleViewingProfile')}`">
          <action-permissions :user="user" />
        </b-tab>
        <b-tab :title="`${this.$t('menu.settings.users.titleActions')}`">
          <action-hierarchy :id="id" />
        </b-tab>
      </b-tabs>
      <div></div>
      <template v-slot:modal-footer="{ cancel }">
        <div class="w-100">
          <button
            :disabled="loading"
            @click="save"
            class="float-right btn btn-primary ml-2"
          >
            {{ $t('menu.settings.users.buttonSave') }}
          </button>
          <button @click="cancel()" class="float-right btn btn-outline-primary">
            {{ $t('menu.settings.users.buttonCancel') }}
          </button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import { mapActions } from 'vuex';
import swal from 'sweetalert';
import BranchPermissions from './branch-permissions';
import IHPermissions from './ih-permissions';
import ActionPermissions from './actions-permissions';
import ActionHierarchy from './action-hierarchy';
import eventBus from '../../../eventBus';

export default {
  props: {
    id: { type: String, required: true },
    user: { type: Object, required: true },
    page: { type: Number },
    limit: { type: Number },
    filter: { type: String },
  },

  components: {
    BranchPermissions,
    IHPermissions,
    ActionPermissions,
    ActionHierarchy,
  },

  data: () => ({
    userAuth: null,
    loading: false,
  }),

  computed: {
    ...mapFields('branches', ['ih1', 'ih2']),
    ...mapFields('profiles', ['permissions', 'profileId']),
  },

  methods: {
    ...mapActions('branches', ['updatePermissions']),
    ...mapActions('master', ['getUsersMaster']),
    ...mapActions('profiles', ['getProfile', 'editProfile']),
    ...mapActions('settings', ['getUsers']),

    successAlert() {
      swal(
        this.$t('menu.settings.users.messages.performedAssignments'),
        this.$t('menu.settings.users.messages.newBranchesAssigned'),
        'success',
      );
    },

    async save() {
      eventBus.$emit('profile-attributes');
      this.loading = true;

      const data = {
        ih1: { selected: this.ih1.selected, all: false },
        ih2: { selected: this.ih2.selected, all: false },
      };

      if (this.ih1.all) {
        data.ih1.all = true;
        data.ih1.selected = null;
      }

      if (this.ih2.all) {
        data.ih2.all = true;
        data.ih2.selected = null;
      }

      data.updatedBy = this.userAuth._id;

      this.updatePermissions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        userId: this.user._id,
        data,
      })
        .then(async () => {
          this.getUsers({
            companyId: this.userAuth.companyId,
            token: this.userAuth.token,
            userId: this.userAuth._id,
            page: this.page,
            limit: this.limit,
            filter: this.filter,
          });

          this.successAlert();

          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
          swal({
            title: this.$t(
              'menu.settings.users.messages.updatePermissions.text',
            ),
            text: this.$t(
              'menu.settings.users.messages.updatePermissions.description',
            ),
            icon: 'warning',
            dangerMode: true,
          });
        });
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/molecules/modal-permissions/index.vue